import {
  GET_MENU_STATUS,
  SET_MENU_STATUS,
} from "../constants/menu-status-constants";

const initialState = {
  status: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU_STATUS:
      const { status } = action;
      return { ...state, status };
    default:
      return state;
  }
};
